module.exports = __webpack_public_path__ + "static/media/logo_milan.260efd40.png";